import { render, staticRenderFns } from "./ni-icon-arrow-corner.vue?vue&type=template&id=75fcca6e"
import script from "./ni-icon-arrow-corner.vue?vue&type=script&lang=js"
export * from "./ni-icon-arrow-corner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports